import { Box } from '@amzn/awsui-components-console';

/**
 * empty state of the table
 */
export function EmptyState({ title, subtitle, action }) {
    return (
        <Box textAlign="center" color="inherit">
            <Box variant="strong" textAlign="center" color="inherit">
                {title}
            </Box>
            <Box variant="p" padding={{ bottom: 's' }} color="inherit">
                {subtitle}
            </Box>
            {action}
        </Box>
    );
}

/**
 * get filtered item count
 * @param {*} filteredItemsCount
 * @returns
 */
export function getFilterCounterText(filteredItemsCount) {
    if (filteredItemsCount <= 1) {
        return `${filteredItemsCount} match`;
    } else {
        return `${filteredItemsCount} matches`;
    }
}

/**
 * convert epoch time to date
 * @return {String} date string
 */
export function getDate(dateInMillis) {
    const date = new Date(parseInt(dateInMillis));
    return date.toUTCString();
}
